import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetWebPageTableEditParams, WebPageService, WebPageTableEditGet } from '@app/services/web-page.service';
import { debounceTime, from, Subject, switchMap, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'tt-webpage-table-edit',
    templateUrl: './webpage-table-edit.component.html',
    styleUrls: ['./webpage-table-edit.component.css'],
})
export class WebpageTableEditComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetWebPageTableEditParams;

    @Output()
    public submit = new EventEmitter<void>();

    public get?: WebPageTableEditGet;

    public saving = false;

    public loading = false;

    private load$ = new Subject<GetWebPageTableEditParams>();

    private destroy$ = new Subject<void>();

    constructor(
        private webPage: WebPageService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.load$
            .pipe(
                takeUntil(this.destroy$),
                tap({ next: () => (this.loading = true) }),
                debounceTime(50),
                switchMap((params) => from(this.webPage.getWebPageTableEdit(params))),
            )
            .subscribe({
                next: (get) => {
                    this.get = get;
                    this.loading = false;
                },
            });
    }

    public async save() {
        if (!this.get) return;

        try {
            this.saving = true;
            const { iserror, message } = await this.webPage.saveWebPageTableEdit(this.get);

            if ('' + iserror !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: message });
            } else {
                this.navigator?.back();
                this.submit.emit();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;
            if (!!this.params) {
                this.load$.next(this.params);
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            if (!!this.params) {
                this.load$.next(this.params);
            }
        }
    }
}
